module.exports = __webpack_public_path__ + "e9f51cc8892b732a47d8e1bd3f20b606.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MV.svg
// module id = wO5F
// module chunks = 0